<template>
  <div>
    <AlertDialog :open="showConfirm" @update:open="showConfirm = $event">
      <AlertDialogTrigger asChild>
        <Button
          class="tw:block tw:w-full tw:flex tw:items-center tw:justify-center tw:gap-2"
          :loading="loading"
          variant="destructive"
          size="lg"
        >
          <i class="fa fa-stop-circle tw:!text-xl"></i>
          {{ $t("Finish test") }}
        </Button>
      </AlertDialogTrigger>

      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{{ $t("Finish test") }}</AlertDialogTitle>
          <AlertDialogDescription>
            {{ $t("Are you sure you want to finish the test?") }}
          </AlertDialogDescription>
        </AlertDialogHeader>

        <AlertDialogFooter>
          <AlertDialogCancel :disabled="loading">
            {{ $t("Cancel") }}
          </AlertDialogCancel>
          <AlertDialogAction
            variant="destructive"
            :disabled="loading"
            @click="confirmClose"
          >
            {{ $t("Finish test") }}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  </div>
</template>

<script setup>
import { ref } from "vue";
import {
  AlertDialog,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogCancel,
  AlertDialogAction,
} from "@/shadcn/components/ui/alert-dialog";
import { Button } from "@/shadcn/components/ui/button/index.js";

const props = defineProps({
  productTest: {
    required: true,
  },
});

const emit = defineEmits(["close"]);

const showConfirm = ref(false);
const loading = ref(false);

const confirmClose = () => {
  loading.value = true;
  props.productTest
    .close()
    .then(() => {
      emit("close");
      showConfirm.value = false;
    })
    .finally(() => {
      loading.value = false;
    });
};
</script>
